export function isPrimitive<T>(value: T): boolean {
  if (value == null) {
    return true;
  }

  switch (typeof value) {
    case 'number':
    case 'bigint':
    case 'boolean':
    case 'string':
    case 'symbol':
    case 'undefined':
      return true;
    default:
      return false;
  }
}
